ixModuleRouting("impactx.ownsecurityroles", {
    "/ownsecurityrolelist": {
        template: "<ixa-own-security-roles-list></ixa-own-security-roles-list>",
        process: "EditOwnSecurityRoles",
        workspace: "admin",
    },
    "/ownsecurityrole/:id": {
        template: "<ixa-own-security-role></ixa-own-security-role>",
        templateUrl: "modules/ownsecurityroles/templates/ownsecurityrole.html",
        process: "EditOwnSecurityRoles",
        controller: "OwnSecurityRoleController",
        controllerAs: "ownSecurityRoleController",
        workspace: "admin",
    },
});